module.exports = __webpack_public_path__ + "static/media/award_logolounge@2x.71dccc3a.png";